import React from "react";
import { Link } from "react-router-dom";
import "../styling/pagenotfound.css";

const NotFound = () => (
  <div className="not-found-container">
    <div className="not-found-code">404</div>
    <h2>Page Not Found</h2>
    <p>The page you're looking for doesn't exist or has been moved.</p>
    <Link to="/">Go back home</Link>
  </div>
);

export default NotFound;
